<!-- 一站式旅游服务详情 -->
<template>
  <div class="frame guide-page" v-if="page">
    <div class="guide-hero">
      <img
        :src="page.heroImg"
        class="guide-hero-img"
        :alt="page.heroBannerTitle"
      />
      <div class="guide-hero-overlay">
        <!-- <h1 class="guide-hero-title">{{ page.heroBannerTitle }}</h1> -->
      </div>
    </div>
    <div class="guide-content">
      <div class="about-wrap">
        <div class="about-left">
          <div class="about-label">{{ page.en }}</div>
          <h2 class="about-heading">{{ page.title }}</h2>
          <div class="about-body">
            <p
              v-for="(para, index) in page.paragraphs"
              :key="index"
              class="about-desc"
            >
              {{ para }}
            </p>
          </div>
        </div>
        <div class="about-gallery">
          <div
            v-for="(img, index) in page.gallery"
            :key="index"
            class="about-gallery-cell"
          >
            <img :src="img" class="about-gallery-item" :alt="page.title" />
          </div>
        </div>
      </div>
    </div>

    <div class="box4">
      <div class="section-inner">
        <h2 class="section-title section-title--center">
          {{ $t("destinationDetail.photosTitle") }}
        </h2>
        <div class="photo-tabs">
          <button
            v-for="tab in photoTabList"
            :key="tab.key"
            type="button"
            class="photo-tab"
            :class="{ active: activePhotoTab === tab.key }"
            @click="activePhotoTab = tab.key"
          >
            {{ tab.label }}
          </button>
        </div>
        <div class="photo-grid">
          <div
            v-for="(photo, index) in filteredPhotos"
            :key="index"
            class="photo-cell"
          >
            <img :src="photo.src" alt="" />
          </div>
        </div>
      </div>
    </div>

    <div class="box5">
      <div class="section-inner">
        <div class="review-section-head">
          <div class="review-section-label">{{ $t("home.reviews.en") }}</div>
          <h2 class="review-section-title">{{ $t("home.reviews.title") }}</h2>
        </div>
        <p class="review-intro">{{ $t("home.reviews.intro") }}</p>
        <div class="review-columns">
          <div
            class="review-column"
            v-for="platform in reviewPlatforms"
            :key="'col-' + platform.id"
          >
            <div class="review-scroll">
              <div
                class="review-block"
                v-for="(review, rIdx) in platform.reviews"
                :key="rIdx"
              >
                <div class="review-meta">
                  <span class="review-author">{{ review.author }}</span>
                  <span class="review-date">{{ review.date }}</span>
                </div>
                <div
                  class="review-stars"
                  :class="'stars--' + platform.starTheme"
                >
                  <i
                    v-for="n in review.rating"
                    :key="n"
                    class="el-icon-star-on"
                  ></i>
                </div>
                <h4 class="review-block-title" v-if="review.title">
                  {{ review.title }}
                </h4>
                <p class="review-content">{{ review.content }}</p>
                <div class="review-images" v-if="review.image">
                  <img :src="review.image" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getGuidePage } from "../utils/guidePage";
import { enrichReviewPlatforms } from "../utils/reviewAssets";
import { getOurPhotosByTab } from "../utils/ourPhotos";

export default {
  name: "GuidePage",
  data() {
    return {
      page: null,
      activePhotoTab: "all",
    };
  },
  computed: {
    photoTabList() {
      const tabs = this.$t("destinationDetail.photoTabs");
      return Object.keys(tabs).map((key) => ({
        key,
        label: tabs[key],
      }));
    },
    filteredPhotos() {
      return getOurPhotosByTab(this.activePhotoTab);
    },
    reviewPlatforms() {
      return enrichReviewPlatforms(this.$t("home.reviews.platforms"));
    },
  },
  watch: {
    "$route.params.type"() {
      this.loadPage();
    },
    "$i18n.locale"() {
      this.loadPage();
    },
  },
  mounted() {
    this.loadPage();
    window.scrollTo(0, 0);
  },
  methods: {
    loadPage() {
      const { type } = this.$route.params;
      this.page = getGuidePage(type, this.$i18n);
      this.activePhotoTab = "all";
      if (!this.page) {
        this.$router.replace("/");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.guide-page {
  background-color: $box-bg;
}

.guide-hero {
  position: relative;
  width: 100%;
  height: 420px;
  overflow: hidden;
}

.guide-hero-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.guide-hero-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #fff;
  background: rgba(0, 0, 0, 0.35);
}

.guide-hero-title {
  margin: 0;
  padding: 0 40px;
  max-width: 1000px;
  font-size: 42px;
  font-weight: 700;
  line-height: 1.35;
  letter-spacing: 1px;
  text-shadow: 0 4px 24px rgba(0, 0, 0, 0.45);
}

/* 与首页 box1 关于我们一致 */
.guide-content {
  padding: 100px 0 120px;
  background-color: $box-bg;
}

.about-wrap {
  width: 1200px;
  max-width: calc(100% - 80px);
  margin: 0 auto;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 60px;
}

.about-left {
  flex: 0 1 520px;
  width: 520px;
  max-width: 48%;
  min-width: 300px;
  writing-mode: horizontal-tb;
}

.about-label,
.about-heading,
.about-desc {
  writing-mode: horizontal-tb;
  white-space: normal;
  word-break: normal;
  overflow-wrap: break-word;
}

.about-label {
  display: block;
  font-size: 16px;
  font-weight: 500;
  color: #fdc44b;
  letter-spacing: 0.5px;
  margin-bottom: 16px;
}

.about-heading {
  margin: 0 0 24px;
  font-size: 28px;
  font-weight: 700;
  line-height: 1.35;
  color: #1a1a1a;
}

.about-body {
  margin-bottom: 0;
}

.about-desc {
  margin: 0 0 14px;
  font-size: 15px;
  line-height: 1.75;
  color: #666;
  text-align: justify;

  &:last-child {
    margin-bottom: 0;
  }
}

.about-gallery {
  flex: 1 1 560px;
  min-width: 280px;
  max-width: 620px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.about-gallery-cell {
  overflow: hidden;
  border-radius: 16px;
  background: #eef2f6;
  line-height: 0;
}

.about-gallery-item {
  width: 100%;
  height: auto;
  display: block;
  object-fit: contain;
  vertical-align: top;
  transition: transform 0.35s ease;
}

.about-gallery-cell:hover .about-gallery-item {
  transform: scale(1.03);
}

.box4,
.box5 {
  background-color: $box-bg;
  padding: 0 0 80px;
}

.box4 {
  padding-top: 0;
}

.section-inner {
  width: 1200px;
  max-width: calc(100% - 80px);
  margin: 0 auto;
}

.section-title {
  margin: 0 0 28px;
  font-size: 28px;
  font-weight: 700;
  color: #1a1a1a;

  &--center {
    text-align: center;
  }
}

.photo-tabs {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
  margin-bottom: 28px;
}

.photo-tab {
  padding: 8px 18px;
  font-size: 13px;
  color: #666;
  background: #fff;
  border: 1px solid #e0e8f0;
  border-radius: 999px;
  cursor: pointer;
  transition: all 0.2s;

  &.active,
  &:hover {
    color: #1a1a1a;
    border-color: #fdc44b;
    background: rgba(253, 196, 75, 0.15);
  }
}

.photo-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}

.photo-cell {
  border-radius: 12px;
  overflow: hidden;

  img {
    width: 100%;
    height: 200px;
    object-fit: cover;
    display: block;
  }
}

.review-section-head {
  text-align: center;
  margin-bottom: 12px;
}

.review-section-label {
  font-size: 14px;
  font-weight: 500;
  color: #fdc44b;
  letter-spacing: 1px;
  margin-bottom: 8px;
}

.review-section-title {
  margin: 0;
  font-size: 32px;
  font-weight: 700;
  color: #1a1a1a;
}

.review-intro {
  text-align: center;
  max-width: 800px;
  margin: 0 auto 32px;
  font-size: 15px;
  line-height: 1.7;
  color: #666;
}

.review-columns {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

.review-column {
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
}

.review-scroll {
  max-height: 320px;
  overflow-y: auto;
  margin-bottom: 16px;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
}

.review-block {
  padding-bottom: 16px;
  margin-bottom: 16px;
  border-bottom: 1px solid #f0f0f0;

  &:last-child {
    border-bottom: none;
    margin-bottom: 0;
  }
}

.review-meta {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #999;
  margin-bottom: 8px;
}

.review-stars {
  margin-bottom: 8px;
  color: #fdc44b;
}

.review-block-title {
  margin: 0 0 6px;
  font-size: 15px;
  font-weight: 600;
  color: #1a1a1a;
}

.review-content {
  margin: 0;
  font-size: 13px;
  line-height: 1.6;
  color: #666;
}

.review-images {
  margin-top: 12px;

  img {
    width: 200px;
    max-width: 100%;
    height: auto;
    border-radius: 6px;
    object-fit: cover;
  }
}

@media (max-width: 992px) {
  .guide-hero-title {
    font-size: 32px;
    padding: 0 20px;
  }

  .guide-content {
    padding: 60px 0 80px;
  }

  .about-wrap {
    flex-direction: column;
    gap: 40px;
  }

  .about-left {
    flex: 1 1 auto;
    width: 100%;
    max-width: 100%;
    min-width: 0;
  }

  .about-heading {
    font-size: 24px;
  }

  .about-gallery {
    flex: 1 1 auto;
    width: 100%;
    max-width: 100%;
  }

  .photo-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .review-columns {
    grid-template-columns: 1fr;
  }
}
</style>
